/**
 * Check that the binding authority limit is not exceeded for policies.
 * Matches UW rules POL001 / POLICY004 / POLICY005:
 * moment().diff(moment(policy.PolicyEffectiveDateDt), 'days') > maxPastDays
 */
export function isEffectiveDateOutsideBindingAuthority( effectiveDate: string, maxPastDays: number = 5 ): boolean {
    if (!effectiveDate || maxPastDays === -1) {
      return false;
    }
  
    const datePart = effectiveDate.split('T')[0];
    const [year, month, day] = datePart.split('-').map(Number);
    const effective = new Date(year, month - 1, day);
  
    if (isNaN(effective.getTime())) {
      return false;
    }
  
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    effective.setHours(0, 0, 0, 0);
  
    const diffDays = Math.floor((today.getTime() - effective.getTime()) / (24 * 60 * 60 * 1000));
  
    return diffDays > maxPastDays;
  }